import * as Accountant from 'app/calcs/Accountant'
import { FandfPensionCalculations } from 'app/calcs/customers/fandf'
import { IOPensionCalculations } from 'app/calcs/customers/IO'
import { makeIOComputer } from 'app/calcs/customers/IO/Factory';
import { Local145PensionCalculations } from 'app/calcs/customers/local145';
import { Local697PensionCalculations } from 'app/calcs/customers/local697'
import { Local697PlanPPensionCalculations } from 'app/calcs/customers/local697PlanP'
import { Local701PensionCalculations } from 'app/calcs/customers/local701'
import { Local705PensionCalculations } from 'app/calcs/customers/local705'
import { NCPERSPriorPensionCalculations } from 'app/calcs/customers/ncpers/prior'
import { NEBFPensionCalculations } from 'app/calcs/customers/NEBF'
import { makeNEBFComputer } from 'app/calcs/customers/NEBF/Factory';
import { defaultMonthlyPensionPayment, FormOfPaymentOptions } from 'app/calcs/pensions'
import { AllFormsOfPayment, IMonthlyPensionPayments, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import { SpousalIncomeType, SpousalPensionCalculations } from 'app/calcs/pensions/spousal'
import { MaterialInput } from 'app/components';
import { IQuestionsGroupContainerProps, QuestionsGroupContainer } from 'app/containers/PipelineSection/QuestionGroupContainer'
import { INcpersPensionInputs, INcpersRunCalculationsRequest, NcpersActions } from 'app/redux/Customers/ncpers/actions'
import { dateAtAge, IRetirementPerson, isSamePersonForSSA, Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import { getBrandInfo } from 'config'
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'

interface IPensionSummaryState {
  profile: Profile
  member: IRetirementPerson
  spouse: IRetirementPerson
  monthlyPayments: IMonthlyPensionPayments[]
}

enum PensionType {
  NCPERSCurrent,
  NCPERSPrior,
  Spousal,
  Fandf,
  Local705,
  Local701,
  IO,
  NEBF,
  Local697,
  Local607PlanP,
  LocalXXX,
  Local401,
  Local74,
  Local145,
  MAX
}

class PensionSummaryContainer extends QuestionsGroupContainer<IQuestionsGroupContainerProps, {}> {

  state: IPensionSummaryState = {
    profile: null,
    member: null,
    spouse: null,
    monthlyPayments: _.times(PensionType.MAX, () => defaultMonthlyPensionPayment)
  }

  componentWillMount() {
    this.onAppStateUpdate((appState) => {
      const profile = appState.Profile.get('info')
      if (null === profile) { return }

      const member = profile.getHeadOfHousehold()
      const spouse = profile.getSpouse()
      const now = moment('2017-12-03') //.utc().startOf('day')

      if (profile.pension.ncpers) {
        const request = { person: member, vals: profile.pension.ncpers, when: null }
        Accountant.getNcpersMonthlyPensionAmount(request)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.NCPERSCurrent] = mpa
            this.setState({ monthlyPayments })
          })
      }

      if (profile.pension.ncpersPrior) {
        const computer = new NCPERSPriorPensionCalculations(profile)
        computer.getMonthlyPensionAmount(computer.getPerson(), computer.getPension(), now)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.NCPERSPrior] = mpa
            this.setState({ monthlyPayments })
          })
      }

      if (profile.pension.spousal) {
        const computer = new SpousalPensionCalculations(profile)
        computer.getMonthlyPensionAmount(computer.getPerson(), computer.getPension(), now)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.Spousal] = mpa
            this.setState({ monthlyPayments })
          })
      }

      if (profile.pension.fandf) {
        const computer = new FandfPensionCalculations(profile)
        computer.setSpouse(profile.getSpouse())
        const when = dateAtAge(profile.getHeadOfHousehold(), profile.pension.fandf.beginPaymentsAge)
        computer.getMonthlyPensionAmount(computer.getPerson(), computer.getPension(), when)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.Fandf] = mpa
            this.setState({ monthlyPayments })
          })
      }

      if (profile.pension.local145) {
        const computer = new Local145PensionCalculations(profile)
        computer.setSpouse(profile.getSpouse())
        const when = dateAtAge(profile.getHeadOfHousehold(), profile.pension.local145.beginPaymentsAge)
        computer.getMonthlyPensionAmount(computer.getPerson(), computer.getPension(), when)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.Local145] = mpa
            this.setState({ monthlyPayments })
          })
      }

      if (profile.pension.local705) {
        const computer = new Local705PensionCalculations(profile)
        computer.setSpouse(profile.getSpouse())
        const when = dateAtAge(profile.getHeadOfHousehold(), profile.pension.local705.beginPaymentsAge)
        computer.getMonthlyPensionAmount(computer.getPerson(), computer.getPension(), when)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.Local705] = mpa
            this.setState({ monthlyPayments })
          })
      }

      if (profile.pension.local701) {
        const computer = new Local701PensionCalculations(profile)
        computer.setSpouse(profile.getSpouse())
        const when = dateAtAge(profile.getHeadOfHousehold(), profile.pension.local701.beginPaymentsAge)
        computer.getMonthlyPensionAmount(computer.getPerson(), computer.getPension(), when)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.Local701] = mpa
            this.setState({ monthlyPayments })
          })
      }

      if (profile.pension.local697) {
        const computer = new Local697PensionCalculations(profile)
        computer.setSpouse(profile.getSpouse())
        const when = dateAtAge(profile.getHeadOfHousehold(), profile.pension.local697.beginPaymentsAge)
        computer.getMonthlyPensionAmount(computer.getPerson(), computer.getPension(), when)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.Local697] = mpa
            this.setState({ monthlyPayments })
          })
      }

      if (profile.pension.IO) {
        const computer = makeIOComputer(profile)
        computer.setSpouse(profile.getSpouse())
        const when = dateAtAge(profile.getHeadOfHousehold(), profile.pension.IO.beginPaymentsAge)
        computer.getMonthlyPensionAmount(computer.getPerson(), computer.getPension(), when)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.IO] = mpa
            this.setState({ monthlyPayments })
          })
      }

      if (profile.pension.NEBF) {
        if (_.isNumber(profile.pension.NEBF.currentYearsService)) {
          // tslint:disable-next-line:no-debugger
          debugger
        }
        const computer = makeNEBFComputer(profile)
        computer.setSpouse(profile.getSpouse())
        const when = dateAtAge(profile.getHeadOfHousehold(), profile.pension.NEBF.beginPaymentsAge)
        computer.getMonthlyPensionAmount(computer.getPerson(), computer.getPension(), when)
          .then((mpa) => {
            const monthlyPayments = this.state.monthlyPayments
            monthlyPayments[PensionType.NEBF] = mpa
            this.setState({ monthlyPayments })
          })
      }

      this.setState({ profile, member, spouse })
    })
  }

  render() {
    if (!this.state.member) { return null }

    const fop = (x: AllFormsOfPayment | SpousalIncomeType) => {
      return FormOfPaymentOptions
        .find((fopo) => fopo.value === x)
        .label
    }

    const monthlyPayments = this.state.monthlyPayments
    const info = _.map(monthlyPayments, (mpa) => {
      return (0 === mpa.amount) ? {
        amount: '-',
        kind: '',
        beginPaymentsAge: '',
        valid: false
      } : {
          amount: utils.toCurrency(mpa.amount),
          kind: fop(mpa.kind),
          beginPaymentsAge: utils.toNiceAge(mpa.beginPaymentsAge),
          valid: true
        }
    })

    const totalPayments = _.sumBy(monthlyPayments, (p) => p.amount)
    const totalPaymentsText = utils.toCurrency(totalPayments)
    const brandName = getBrandInfo().brandName

    const priorPensionText = getBrandInfo().priorPensionTimelineLabel || 'prior'

    return (
      <section className="pensionIncomeSummary">
        <h1>Pension Income Summary</h1>
        <h5 className="lead">Shown below is a summary of the information for all your pensions.</h5>
        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <td></td>
                <td><em>Payments Begin At Age</em></td>
                <td><em>Form of Payment</em></td>
                <td><em>Monthly Amount</em></td>
              </tr>
            </thead>
            <tbody>
              {info[PensionType.Fandf].valid && <tr>
                <td><a href="#/pension/foster___foster_pension">{this.state.member.firstName} ({brandName} pension)</a></td>
                <td>{info[PensionType.Fandf].beginPaymentsAge}</td>
                <td>{info[PensionType.Fandf].kind}</td>
                <td>{info[PensionType.Fandf].amount}</td>
              </tr>}
              {info[PensionType.Local145].valid && <tr>
                <td><a href="#/pension/local_145_pension">{this.state.member.firstName} (Local 145 pension)</a></td>
                <td>{info[PensionType.Local145].beginPaymentsAge}</td>
                <td>{info[PensionType.Local145].kind}</td>
                <td>{info[PensionType.Local145].amount}</td>
              </tr>}
              {info[PensionType.Local697].valid && <tr>
                <td><a href="#/pension/local_697_pension">{this.state.member.firstName} (Local 697 pension)</a></td>
                <td>{info[PensionType.Local697].beginPaymentsAge}</td>
                <td>{info[PensionType.Local697].kind}</td>
                <td>{info[PensionType.Local697].amount}</td>
              </tr>}
              {info[PensionType.Local705].valid && <tr>
                <td><a href="#/pension/local_705_pension">{this.state.member.firstName} (Local 705 pension)</a></td>
                <td>{info[PensionType.Local705].beginPaymentsAge}</td>
                <td>{info[PensionType.Local705].kind}</td>
                <td>{info[PensionType.Local705].amount}</td>
              </tr>}
              {info[PensionType.Local701].valid && <tr>
                <td><a href="#/pension/local_701_pension">{this.state.member.firstName} ({brandName} pension)</a></td>
                <td>{info[PensionType.Local701].beginPaymentsAge}</td>
                <td>{info[PensionType.Local701].kind}</td>
                <td>{info[PensionType.Local701].amount}</td>
              </tr>}
              {info[PensionType.NCPERSCurrent].valid && <tr>
                <td><a href="#/pension/current_pension">{this.state.member.firstName} (current pension)</a></td>
                <td>{info[PensionType.NCPERSCurrent].beginPaymentsAge}</td>
                <td>{info[PensionType.NCPERSCurrent].kind}</td>
                <td>{info[PensionType.NCPERSCurrent].amount}</td>
              </tr>}
              {info[PensionType.NEBF].valid && <tr>
                <td><a href="#/pension/NEBF_pension">{this.state.member.firstName} (NEBF pension)</a></td>
                <td>{info[PensionType.NEBF].beginPaymentsAge}</td>
                <td>{info[PensionType.NEBF].kind}</td>
                <td>{info[PensionType.NEBF].amount}</td>
              </tr>}
              {info[PensionType.IO].valid && <tr>
                <td><a href="#/pension/IO_pension">{this.state.member.firstName} (IO pension)</a></td>
                <td>{info[PensionType.IO].beginPaymentsAge}</td>
                <td>{info[PensionType.IO].kind}</td>
                <td>{info[PensionType.IO].amount}</td>
              </tr>}
              {info[PensionType.NCPERSPrior].valid && <tr>
                <td><a href="#/pension/prior_pension">{this.state.member.firstName} ({priorPensionText} pension)</a></td>
                <td>{info[PensionType.NCPERSPrior].beginPaymentsAge}</td>
                <td>{info[PensionType.NCPERSPrior].kind}</td>
                <td>{info[PensionType.NCPERSPrior].amount}</td>
              </tr>}
              {info[PensionType.Spousal].valid && <tr>
                <td><a href="#/pension/spouse_pension">{this.state.spouse.firstName} (spousal)</a></td>
                <td>{info[PensionType.Spousal].beginPaymentsAge}</td>
                <td>{info[PensionType.Spousal].kind}</td>
                <td>{info[PensionType.Spousal].amount}</td>
              </tr>}
              <tr className="grad-bg">
                <td>TOTAL MONTHLY PAYMENTS</td>
                <td></td>
                <td></td>
                <td>{totalPaymentsText}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {getBrandInfo().markup.pension.summary.underTable}
        <br />
        <a href="#/dashboard" className="backtodash-link">
          <i className="fa fa-fw fa-arrow-left" />
          &nbsp;Back to Dashboard
        </a>
      </section>
    )
  }
}

const PensionSummary = () => (
  <PensionSummaryContainer
    header="Summary" icon="" />
)

export {
  PensionSummary
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Pension/Summary/index.tsx